import { GuideStatus, GuideStatusItem } from '../types/guide';
import { GuideItemResponse, GuideStatusResponse } from '../types/response/guide-status-response';

export const mapGuideItemFromDTO = (dto: GuideItemResponse): GuideStatusItem => ({
  key: dto.key,
  completed: dto.completed,
});

export const mapGuideStatusFromDTO = (dto: GuideStatusResponse): GuideStatus => ({
  visible: dto.visible,
  dismissed: dto.dismissed,
  items: dto.items.map(mapGuideItemFromDTO),
});
